"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContractsListPanel;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_bootstrap_typeahead_1 = require("react-bootstrap-typeahead");
require("react-bootstrap-typeahead/css/Typeahead.css");
function contractLabel(contract) {
    const id = "ourId" in contract ? contract.ourId : contract.number || "";
    return `${id}${contract.alias ? " | " + contract.alias : ""} ${contract.name || ""}`.trim();
}
function coordinatorName(contract) {
    const manager = "ourId" in contract ? contract._manager : contract._ourContract?._manager;
    return manager ? `${manager.surname} ${manager.name}` : "";
}
function scrollToContract(contractId) {
    // czekamy na re-render (po zaznaczeniu), potem przewijamy TYLKO wewnętrzną listę
    requestAnimationFrame(() => {
        const el = document.getElementById(`scrumContractRow${contractId}`);
        const container = el?.closest(".scrum-contracts-list");
        if (!el || !container)
            return;
        // wyśrodkuj element w kontenerze bez przewijania całego okna
        const delta = el.getBoundingClientRect().top -
            container.getBoundingClientRect().top -
            (container.clientHeight - el.clientHeight) / 2;
        container.scrollTo({ top: container.scrollTop + delta, behavior: "smooth" });
        el.classList.remove("section-scroll-highlight");
        void el.offsetWidth;
        el.classList.add("section-scroll-highlight");
        el.addEventListener("animationend", () => el.classList.remove("section-scroll-highlight"), { once: true });
    });
}
function ContractsListPanel({ contracts, discussedByContractId, selectedContractId, onSelectContract, onToggleDiscussed, }) {
    const [sortKey, setSortKey] = (0, react_1.useState)("alias");
    const [discussedToBottom, setDiscussedToBottom] = (0, react_1.useState)(false);
    const [coordinators, setCoordinators] = (0, react_1.useState)([]);
    const coordinatorOptions = (0, react_1.useMemo)(() => Array.from(new Set(contracts.map(coordinatorName).filter(Boolean))).sort((a, b) => a.localeCompare(b, "pl")), [contracts]);
    const visibleContracts = (0, react_1.useMemo)(() => {
        const withComparable = contracts
            .map((c) => ({
            contract: c,
            coordinator: coordinatorName(c),
            discussed: discussedByContractId.get(c.id) ?? false,
        }))
            .filter((x) => coordinators.length === 0 || coordinators.includes(x.coordinator));
        withComparable.sort((a, b) => {
            if (discussedToBottom && a.discussed !== b.discussed)
                return a.discussed ? 1 : -1;
            if (sortKey === "coordinator") {
                const byCoord = a.coordinator.localeCompare(b.coordinator, "pl");
                if (byCoord !== 0)
                    return byCoord;
            }
            return contractLabel(a.contract).localeCompare(contractLabel(b.contract), "pl");
        });
        return withComparable;
    }, [contracts, discussedByContractId, sortKey, discussedToBottom, coordinators]);
    function clearFilters() {
        setSortKey("alias");
        setDiscussedToBottom(false);
        setCoordinators([]);
    }
    let lastWasDiscussed = false;
    return (react_1.default.createElement("div", { className: "scrum-contracts-panel" },
        react_1.default.createElement("div", { className: "bg-light p-2 rounded-3 mb-3 scrum-filter-panel" },
            react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: "scrum-contract-jump", size: "sm", className: "mb-2", placeholder: "Skocz do umowy\u2026", options: contracts, labelKey: (c) => contractLabel(c), selected: [], onChange: (sel) => {
                    if (!sel[0])
                        return;
                    const c = sel[0];
                    onSelectContract(c); // od razu zaznacz i pokaż szczegóły po prawej
                    scrollToContract(c.id);
                } }),
            react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: "scrum-coordinator-filter", multiple: true, size: "sm", className: "mb-2", placeholder: "Filtruj po koordynatorach\u2026", options: coordinatorOptions, selected: coordinators, onChange: (sel) => setCoordinators(sel) }),
            react_1.default.createElement("div", { className: "d-flex gap-2 align-items-center flex-wrap" },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { size: "sm", style: { width: "auto" }, value: sortKey, onChange: (e) => setSortKey(e.target.value) },
                    react_1.default.createElement("option", { value: "alias" }, "Sortuj: kod | alias"),
                    react_1.default.createElement("option", { value: "coordinator" }, "Sortuj: koordynator")),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", id: "scrum-discussed-to-bottom", label: "Om\u00F3wione na d\u00F3\u0142", checked: discussedToBottom, onChange: (e) => setDiscussedToBottom(e.target.checked) })),
            react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mt-2" },
                react_1.default.createElement("span", { className: "text-muted small" },
                    "Znaleziono: ",
                    visibleContracts.length,
                    " um\u00F3w"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: clearFilters }, "Wyczy\u015B\u0107 filtry"))),
        react_1.default.createElement("div", { className: "scrum-contracts-list" }, visibleContracts.map(({ contract, discussed, coordinator }) => {
            const showSeparator = discussedToBottom && discussed && !lastWasDiscussed;
            lastWasDiscussed = discussed;
            const id = "ourId" in contract ? contract.ourId : contract.number;
            return (react_1.default.createElement(react_1.default.Fragment, { key: contract.id },
                showSeparator && react_1.default.createElement("hr", { className: "scrum-discussed-separator" }),
                react_1.default.createElement("div", { id: `scrumContractRow${contract.id}`, className: "scrum-contract-item d-flex align-items-center gap-2" +
                        (contract.id === selectedContractId ? " active" : "") +
                        (discussed ? " discussed" : "") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", title: "Om\u00F3wiony na planowaniu", checked: discussed, onChange: (e) => onToggleDiscussed(contract.id, e.target.checked), onClick: (e) => e.stopPropagation() }),
                    react_1.default.createElement("div", { className: "flex-grow-1 scrum-contract-label", onClick: () => onSelectContract(contract) },
                        react_1.default.createElement("span", { className: "fw-semibold" },
                            id,
                            contract.alias ? ` | ${contract.alias}` : ""),
                        react_1.default.createElement("span", { className: "d-block text-secondary small text-truncate" }, contract.name),
                        coordinator && react_1.default.createElement("span", { className: "d-block text-muted small" }, coordinator)))));
        }))));
}
